import { ChangeDetectionStrategy, Component, ElementRef, Injector, OnInit } from '@angular/core';
import { slideInAnimation } from './animations';
import { ActivationEnd, ChildrenOutletContexts, Router, RouterOutlet } from '@angular/router';
import { CoreService, ServiceList } from 'core';
import { AppDetailsModel } from 'core/lib/services/models/app-details.model';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen'
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { DeviceService } from 'core/lib/services/device/device.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    slideInAnimation
  ]
})
export class AppComponent implements OnInit {
  title = 'hybrid-platform';
  hideFooter: boolean = false;
  links = [{
    icon: 'house',
    path: '/home',
    id: 'home'
  },
  {
    icon: 'magnifying-glass',
    path: '/search',
    id: 'search',
  },
  {
    icon: 'map-location-dot',
    path: '/map',
    id: "map"
  },]
  appStyle: Style | null = null;
  constructor(private contexts: ChildrenOutletContexts, private injectorObj: Injector, private elementRef: ElementRef, private router: Router, private core: CoreService) {
    // this.injectorObj.get(CoreService).boot()
    this.router.events.subscribe(data => {
      if (data instanceof ActivationEnd) {
        console.log(data.snapshot.data)
        const footerData = data.snapshot.data?.['footer'];
        this.hideFooter = footerData?.show??false;
        // console.log("injector: "+this.injectorObj.get(CoreService));
       
        this.setStatusBar();
        
        // void this.injectorObj.get(CoreService).applyStatusBarStyle(Style.Light, Style.Dark);
      }
    });
  }
  
  ngOnInit(): void {
    SplashScreen.hide().then(() => {
      console.log('call splash hide')
      setTimeout(async () => {
        await this.setStatusBar()
        // await this.setStatusBar()
      }, 500)
    })

    this.injectorObj.get(CoreService).appLoadedSubject.subscribe((appData) => {
      console.log(appData)
      this.elementRef.nativeElement.style.setProperty('--accent-color', (appData as AppDetailsModel).web_app_primary_color)
      this.elementRef.nativeElement.style.setProperty('--ion-color-primary', (appData as AppDetailsModel).web_app_primary_color)
      // this.injectorObj.get(CoreService).preloadData([ServiceList.Tour, ServiceList.SiteSection, ServiceList.Exhibit])
    // this.elementRef.nativeElement.style.setProperty('--secondary-info', '#696969')
      this.injectorObj.get(CoreService).preloadData([ServiceList.GeoSettings, ServiceList.Tour, ServiceList.Exhibit, ServiceList.Info, ServiceList.EventTime, ServiceList.Video])
      

    })
    // this.injectorObj.get(CoreService).preloadData([ServiceList.Tour, ServiceList.Category, ServiceList.SiteSection])
  }
  async setStatusBar() {
    const appStyle = this.core.getStatusBarStyle(Style.Light, Style.Dark)
    console.log(`app style: ${appStyle}`)
    // console.log("Status Style?: "+this.appStyle)
    if (appStyle) {
      await StatusBar.setStyle({ style: appStyle })
    }
    // await this.core.applyStatusBarStyle(Style.Light, Style.Dark)
  }
  // getState(outlet: RouterOutlet) {
  //   // console.log(outlet)
  //   // Changing the activatedRouteData.state triggers the animation
  //   return outlet.activatedRouteData['state'];
  // }
  // hideBottomBar(): boolean {
  //   const footerData  = this.contexts.getContext('primary')?.route?.snapshot?.data?.['footer']
  //   return footerData?.show??false
  //   // let hideFor = ['splash']
  //   // let hide = true
  //   // hideFor.forEach((hx) => {
  //   //   if (this.router.url == hx) {
  //   //     hide = true
  //   //   }
  //   // })
  //   // return hide
  // }
}
